import { getEnvVariable } from "@/business/shared/commons/envUtils/getEnvVariable";
import { exportSharedExcelUrl } from "@/business/sharedSample/infrastructure/constants/urls";

export const exportSharedExcel = {
  async execute(): Promise<string> {
    return getEnvVariable
      .execute("VUE_APP_DACCACH_URL")
      .concat(exportSharedExcelUrl);
  },
};
